/* unplugin-vue-components disabled */import { render } from "./foote.vue?vue&type=template&id=173a6747"
const script = {}

import "./foote.vue?vue&type=style&index=0&id=173a6747&lang=less"

import exportComponent from "/opt/jenkins/workspace/zhishiOfficialweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__